<template>
  <div class="auth-background" :style="backgroundImage">
    <div class="auth-background_mask">
      <div class="auth-layout">
        <router-view/>
      </div>
      <div class="build-number">{{ buildNumber }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "auth",
  data() {
    return {
      buildNumber: process.env.VUE_APP_BUILD_NUMBER
          ? "Сборка: " + process.env.VUE_APP_BUILD_NUMBER
          : "",
      backgroundAmount: 18
    }
  },
  computed: {
    backgroundImage() {
      let getRandomInt = max => Math.floor(Math.random() * Math.floor(max)) + 1

      return {
        background: 'url(' + require('@/assets/backgrounds/' + getRandomInt(this.backgroundAmount) + '.jpeg') + ') center/cover'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-background {
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;

  &_mask {
    background-color: rgba(0, 0, 0, .5);
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
  }
}

.auth-layout {
  max-width: 300px;
  margin: 5vh auto 0 auto;
  padding: 32px 32px 20px 32px;

  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 20px 40px 0 rgba(0,0,0,.5);
  overflow: hidden;
  transition: height .2s ease-in;
}

.build-number {
  position: fixed;
  bottom: 0;
  padding-bottom: 5px;
  width: 100%;

  font-size: 12px;
  color: #222;
  text-align: center;
}
</style>
